import {useIntl} from 'react-intl'
import crossIcon from '../../../../../_metronic/assets/images/svg/data-room/cross-black-icon.svg'
import {useState} from 'react'
import {Formik} from 'formik'
import * as Yup from 'yup'
import {useThemeMode} from '../../../../../_metronic/partials'
import TextInput from '../../../widgets/components/Input/TextInput'
import {BasicButton} from '../../../widgets/components/UI/BasicButton'
export const DataTableFilter = ({filter, setFilter, setClear, setDate}: any) => {
  const {formatMessage} = useIntl()
  const {mode} = useThemeMode()
  const [filterLoading, setFilterLoading] = useState(false)
  const initialValues = {
    date: '',
  }
  const userSchema = Yup.object().shape({
    date: Yup.string().nullable(),
  })
  const closeFilter = () => {
    setFilter(false)
  }

  const clearFilters = (formik: any) => {
    formik.resetForm()
    setClear(true)
    setFilter(false)
    setDate('')
  }

  const onApplyFilter = async (values: any) => {
    setDate(values.date)
    setFilterLoading(true)
    setFilterLoading(false)
    setFilter(false)
    setClear(false)
  }

  return (
    <div
      className={filter ? 'bg-body drawer drawer-end drawer-on' : 'bg-body drawer drawer-end'}
      id='fc-filter'
      data-kt-drawer='true'
      data-kt-drawer-name='filter'
      data-kt-drawer-overlay='true'
      data-kt-drawer-activate='true'
      data-kt-drawer-width="{default:'300px', 'md': '400px'}"
      data-kt-drawer-direction='end'
    >
      {/* Card */}
      <div className='card shadow-none rounded-0 w-100'>
        {/* Header */}
        <div className='card-header' id='fc_header'>
          <div className='card-toolbar gap-6'>
            <button
              type='button'
              className='btn btn-sm btn-icon explore-btn-dismiss me-n5'
              onClick={closeFilter}
            >
              <img src={crossIcon} alt='Close' />
            </button>
            <h5 className='card-title fw-bold'>{formatMessage({id: 'Sort or Filter'})}</h5>
          </div>
        </div>
        {/* Body */}
        <Formik
          initialValues={initialValues}
          validationSchema={userSchema}
          onSubmit={onApplyFilter}
          validateOnMount
          enableReinitialize
        >
          {(formik: any) => {
            return (
              <>
                <div className='card-body'>
                  {/* Clear All Filters */}
                  <div className='mb-5'>
                    <BasicButton
                      id='fc-clear'
                      height='36px'
                      border='none'
                      color={mode === 'dark' ? '#323248' : '#F5F8FA'}
                      textColor={mode === 'dark' ? '#FFFFFF' : '#585960'}
                      padding='8px 16px'
                      buttonText={formatMessage({id: 'Clear All filters'})}
                      minWidth={125}
                      onClick={() => clearFilters(formik)}
                    />
                  </div>
                  <TextInput
                    fieldType='date'
                    fieldName='date'
                    formik={formik}
                    label={formatMessage({id: 'By Date'})}
                    placeholder={formatMessage({id: 'Enter date'})}
                    toolTipText={formatMessage({
                      id: 'Select the date for the meeting to be scheduled.',
                    })}
                    isWidthNotRequired={true}
                    isTooltipNotRequired={true}
                  />
                </div>
                {/* Footer */}
                <div
                  className='d-flex justify-content-center m-md-5 m-0 w-100 w-md-auto px-4'
                  id='fc_footer'
                >
                  <BasicButton
                    id='fc-apply'
                    border='#4776E6'
                    color='#4776E6'
                    textColor='#FFFFFF'
                    // padding="16px 138px"
                    buttonText={formatMessage({id: 'Apply filters'})}
                    minWidth={352}
                    loading={filterLoading}
                    disabled={filterLoading || !formik.isValid}
                    onClick={() => onApplyFilter(formik.values)}
                    customClass='w-100 mb-md-0 mb-4 custom-button-property'
                  />
                </div>
              </>
            )
          }}
        </Formik>
      </div>
    </div>
  )
}
